import {expect} from 'chai';

describe('SDkConnector', () => {
  it('TODO', () => {
    expect(true).to.eq(true);
  });
});
